import React from "react";
import { Box, Typography } from "@mui/material";
import Dashboard from "../components/Dashboard";

const UserDashboard = () => (
  <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1400, mx: "auto" }}>
    <Typography variant="h4" gutterBottom fontWeight={600}>
      Dashboard
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      Your personalized charts, leaders, and live scores.
    </Typography>
    <Dashboard dashboardType="home" isEditable />
  </Box>
);

export default UserDashboard;
